import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { getStories } from "../lib/api";
import { Quote } from "lucide-react";

const FILTERS = ["All", "Leadership", "Education", "Employment", "Community Service", "Mental Health", "Life Skills"];

export default function SuccessStories() {
  const [filter, setFilter] = useState("All");
  const { data: stories = [], isLoading } = useQuery({
    queryKey: ["stories", filter],
    queryFn: () => getStories(filter),
  });

  return (
    <>
      <section className="bg-[#FDFBF7] border-b border-black/10">
        <div className="container-x py-20 md:py-28">
          <span className="overline text-[#6B21A8]">Success Stories</span>
          <h1 className="mt-4 font-display text-5xl md:text-7xl font-bold tracking-tight leading-none">Real lives.<br /><span className="italic">Real change.</span></h1>
          <p className="mt-8 max-w-2xl text-black/70 text-lg">
            These are young men we've walked with — some who came in reluctant, some who came in broken, all of them different when they left.
          </p>
        </div>
      </section>

      <section className="bg-white sticky top-16 md:top-[73px] z-20 border-b border-black/10">
        <div className="container-x py-4 flex flex-wrap gap-2" data-testid="story-filters">
          {FILTERS.map((f) => (
            <button
              key={f}
              onClick={() => setFilter(f)}
              data-testid={`story-filter-${f.replace(/\s+/g, "-").toLowerCase()}`}
              className={`rounded-full border px-4 py-1.5 text-sm font-medium transition ${
                filter === f
                  ? "border-[#6B21A8] bg-[#6B21A8] text-white"
                  : "border-black/15 text-black/70 hover:border-[#6B21A8]"
              }`}
            >
              {f}
            </button>
          ))}
        </div>
      </section>

      <section className="bg-white">
        <div className="container-x py-16">
          {isLoading ? (
            <p className="text-black/60">Loading stories…</p>
          ) : stories.length === 0 ? (
            <p className="text-black/60">No stories yet for this tag — check back soon.</p>
          ) : (
            <div className="grid gap-8 md:grid-cols-2">
              {stories.map((s) => (
                <article key={s.id} data-testid={`story-${s.id}`} className="card-editorial overflow-hidden">
                  <div className="aspect-[4/3] overflow-hidden">
                    <img src={s.image} alt="" className="h-full w-full object-cover" />
                  </div>
                  <div className="p-8">
                    <div className="flex items-center gap-2 flex-wrap">
                      {s.tags.map((t) => <span key={t} className="text-[10px] font-bold uppercase tracking-widest text-[#6B21A8]">{t}</span>)}
                    </div>
                    <Quote className="mt-6 h-8 w-8 text-[#F5B90A]" />
                    <p className="mt-4 font-display text-2xl leading-snug text-black">“{s.quote}”</p>
                    <p className="mt-6 text-sm text-black/70 leading-relaxed">{s.body}</p>
                    <p className="mt-6 text-xs uppercase tracking-widest text-black/50">
                      <span className="font-semibold text-black">{s.student_name}</span> · {s.school} · Class of {s.year}
                    </p>
                  </div>
                </article>
              ))}
            </div>
          )}
        </div>
      </section>
    </>
  );
}
